import React from 'react';

const ForgotPasswordControl = ({ onLinkClick, forgotPassText }) => {
  const style = {
    color: '#767b92',
    display: 'inline-block',
    margin: '2px 0 5px',
    textDecoration: 'none',
    marginTop: 7,
    fontSize: 12,
    fontWeight: 500
  };
  const resetClickHandler = event => {
    event.preventDefault();
    onLinkClick();
  };
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a id="resetPasswordLink" style={style} onClick={resetClickHandler} href="">
      {forgotPassText}
    </a>
  );
};

export default ForgotPasswordControl;



// WEBPACK FOOTER //
// ./components/login/ForgotPasswordControl.jsx